import React from "react";
import { useSelector } from "react-redux";
import { EsNoProcedente } from "./_EsNoProcedente";
import { FormaNoProcedente } from "./_FormaNoProcedente";
import { BotonesCopiarClipboard } from "../incidencias/_BotonesCopiarClipboard";

export const NoProcedente = () => {
  const { esNoProcedente } = useSelector(
    (state) => state.detalleReducer.asistencia
  );

  if (esNoProcedente) return <EsNoProcedente />;

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
      <FormaNoProcedente />
      <BotonesCopiarClipboard />
    </div>
  );
};
